import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    label: string;
    allProjectsLinkAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button label for navigating to all projects */
            label: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AllProjectsButton.label?c=1s4rel3o4dxvr", defaultMessage: "All Projects" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the all projects link */
            allProjectsLinkAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AllProjectsButton.allProjectsLinkAriaLabel?c=23qravduqyqd2", defaultMessage: "All Projects Link" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
